import { Communication } from './communication';
import { Person } from './person';

export class Mentor extends Person {
  telefon2: Communication;
  addon?: string;
  workNote?: string;
}
